import {
  type OutgoingInvoice,
  RequestForInvoicingTypeEnum,
  useRequestForInvoicingQuery,
} from "@src/__generated__/graphql";
import { Spinner } from "@src/components/ui-kit";
import { useStore } from "@src/utils/hooks";
import { FormMode } from "@src/utils/types";
import { observer } from "mobx-react-lite";
import { type FC, useEffect, useState } from "react";
import { Container } from "../components";
import {
  InvoiceStore,
  InvoiceStoreContext,
  InvoiceTypeEnum,
  InvoiceTypeEnumFrom,
} from "../store";

type DuplicateRequestForInvoicingProps = {
  id: OutgoingInvoice["id"];
};

const INVOICE_TYPE = InvoiceTypeEnum.CreditNote;

export const DuplicateRequestForInvoicing: FC<DuplicateRequestForInvoicingProps> =
  observer(function DuplicateRequestForInvoicing({ id }) {
    const appStore = useStore();
    const [store] = useState(
      () => new InvoiceStore(appStore, true, INVOICE_TYPE, FormMode.DUPLICATE),
    );

    const { data, loading } = useRequestForInvoicingQuery({
      variables: { id },
    });

    useEffect(() => {
      if (!data?.requestForInvoicing) return;
      store.type = InvoiceTypeEnumFrom(data.requestForInvoicing.type);
      store.duplicate(data.requestForInvoicing);
      store.setSteps(
        data.requestForInvoicing.type ===
          RequestForInvoicingTypeEnum.CreditNote,
      );
    }, [data?.requestForInvoicing]);

    if (loading) {
      return <Spinner absolute />;
    }

    return (
      <InvoiceStoreContext.Provider value={store}>
        <Container />
      </InvoiceStoreContext.Provider>
    );
  });
